import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnsnoozeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unsnooze",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.14 30.57c-.29 0-.58-.11-.81-.33L.19 5.09a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95ZM7.87 5.3c-.4 0-.79-.21-1-.59-.31-.55-.11-1.25.45-1.55.77-.43 1.6-.8 2.45-1.09.6-.21 1.25.11 1.46.7.21.6-.11 1.25-.7 1.46-.73.25-1.43.57-2.1.93-.17.1-.36.14-.55.14ZM14.71 30.57c-8.19 0-14.85-6.66-14.85-14.86 0-1.72.29-3.39.87-4.97a1.145 1.145 0 1 1 2.15.79 12.2 12.2 0 0 0-.73 4.18c0 6.93 5.64 12.57 12.57 12.57 1.45 0 2.85-.24 4.16-.72.59-.22 1.25.09 1.47.68s-.09 1.25-.68 1.47c-1.56.57-3.23.86-4.95.86ZM26.14 23.93c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56.04-.08.09-.15.13-.23-.71.12-1.41.17-2.18.17a1.14 1.14 0 1 1 0-2.28c1.35 0 2.42-.19 3.81-.66.42-.14.87-.04 1.18.27s.41.77.27 1.18c-.33.94-.74 1.85-1.23 2.7-.21.37-.6.57-.99.57ZM30.71 8.86H25c-.46 0-.88-.28-1.06-.71s-.08-.92.25-1.25l3.76-3.76H25a1.14 1.14 0 1 1 0-2.28h5.71c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-3.76 3.76h2.95a1.14 1.14 0 1 1 0 2.28M20.43 13.43h-4.57c-.46 0-.88-.28-1.06-.71s-.08-.92.25-1.25l2.62-2.62h-1.81a1.14 1.14 0 1 1 0-2.28h4.57c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-2.62 2.62h1.81a1.14 1.14 0 1 1 0 2.28"
    })
  }));
};